// extracted by mini-css-extract-plugin
export default {"simpleTableStyles":"styles_simpleTableStyles__y6V4h","stickyFirstCol":"styles_stickyFirstCol__K+B0L"};